module.exports = __webpack_public_path__ + "b64a9f15bc703b7d3a45058cb4e6d8f4.woff";